import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=897a2136&scoped=true"
import script from "./OrderOverview.vue?vue&type=script&lang=js"
export * from "./OrderOverview.vue?vue&type=script&lang=js"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=897a2136&prod&lang=scss&scoped=true"
import style1 from "./OrderOverview.vue?vue&type=style&index=1&id=897a2136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a2136",
  null
  
)

export default component.exports